// App.jsx - Pluto Loans with Pre-Apply Page

import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import PreApply from "./pages/PreApply";

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pre-apply" element={<PreApply />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
